import { RouteConfig } from 'vue-router';
import MswProductClaims from './components/msw-product-claims.vue';

const route:RouteConfig = {
  path: 'claimsreport',
  component: MswProductClaims,
};

export function getDefaultParams() {
  return {};
}

export default route;
